import { Component, OnInit } from '@angular/core';

import {
  IconComponent,
  IconType,
} from '@webapp/ui';


@Component({
  selector: 'app-payment-link-error-page',
  standalone: true,
  imports: [
    IconComponent
],
  templateUrl: './global-error-page.component.html',
  styleUrl: './global-error-page.component.scss',
})
export class GlobalErrorComponent implements OnInit {

  message = '';
  type = '';
  title = '';
  ngOnInit(): void {
    this.message = history.state.message;
    this.type = history.state.type;
    this.title = history.state.title;
  }

  getIcon(): IconType {
    return (this.type === 'error' ? 'exclamation_circle' : 'alert_warning') as IconType;
  }


}
